import type { ModalCopy } from "@circle-react-shared/TrixEditor/InlineModalSelector/ModalCopy";
import type { DropzoneFile } from "@circleco/compass/components/Dropzone";
import { Dropzone } from "@circleco/compass/components/Dropzone";

export interface UploadPanelProps {
  accept?: string[];
  copy: ModalCopy;
  files: DropzoneFile[];
  onFilesChange: (files: DropzoneFile[]) => void;
}

export const UploadPanel = ({
  accept,
  copy,
  files,
  onFilesChange,
}: UploadPanelProps) => (
  <Dropzone
    accept={accept}
    title={copy.dropTitle}
    description={copy.helperText}
    value={files}
    onValueChange={onFilesChange}
  />
);
